export default {"src":"/_next/static/media/laptop.e050f018.svg","height":628,"width":971};